import React from 'react';
import PropTypes from 'prop-types';

import { cls } from '@mssgme/helpers';
import { getProps } from './PureButton';

import styles from './IconButton.scss';

IconButton.propTypes = {
    as: PropTypes.elementType,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

IconButton.defaultProps = {
    as: 'button',
};

export default function IconButton({ as: Component, children, disabled, ...rest }) {
    return (
        <Component {...cls([styles.button, disabled && styles.disabled], getProps(Component, rest))}>
            {children}
        </Component>
    );
}
